import { render, staticRenderFns } from "./configContent.vue?vue&type=template&id=42537298&scoped=true&"
import script from "./configContent.vue?vue&type=script&lang=js&"
export * from "./configContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42537298",
  null
  
)

export default component.exports